<template>
  <div class="d-flex align-items-center justify-content-center" style="margin-top: 20vh; margin-bottom: 20vh">
    <slot />
  </div>
</template>